import { categories } from '@/mocks/categories';

const productImages = [
  'https://readdy.ai/api/search-image?query=Single%20clean%20white%20leather%20sneaker%20floating%20above%20warm%20terracotta%20clay%20surface%20with%20dramatic%20golden%20sunset%20backlight%20creating%20long%20shadow%2C%20minimal%20composition%2C%20artistic%20product%20photography%2C%20warm%20earthy%20tones%2C%20mediterranean%20evening%20atmosphere%2C%20isolated%20product%20focus%2C%20high%20end%20editorial%20style&width=800&height=960&seq=superbuy-product-shoes-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Soft%20charcoal%20gray%20hoodie%20draped%20elegantly%20over%20natural%20rattan%20chair%20on%20warm%20wooden%20floorboards%2C%20gentle%20morning%20light%20from%20large%20window%2C%20soft%20sage%20green%20wall%20background%2C%20cozy%20minimal%20interior%2C%20natural%20fabric%20texture%20visible%2C%20calm%20serene%20atmosphere%2C%20nordic%20interior%20styling%2C%20editorial%20fashion%20photography&width=800&height=960&seq=superbuy-product-hoodies-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Structured%20tan%20leather%20tote%20bag%20placed%20on%20smooth%20marble%20surface%20with%20warm%20amber%20ambient%20lighting%2C%20single%20olive%20branch%20beside%20it%20for%20organic%20contrast%2C%20luxurious%20minimal%20composition%2C%20warm%20golden%20and%20cream%20tones%2C%20sophisticated%20product%20photography%2C%20gentle%20reflection%20on%20polished%20surface%2C%20elegant%20refined%20aesthetic&width=800&height=960&seq=superbuy-product-bags-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Delicate%20gold%20toned%20minimalist%20jewelry%20pieces%20including%20thin%20chain%20necklace%20and%20simple%20ring%20arranged%20on%20raw%20unpolished%20stone%20surface%2C%20soft%20diffused%20natural%20light%2C%20warm%20neutral%20beige%20and%20sand%20tones%2C%20organic%20texture%20contrast%2C%20artistic%20editorial%20product%20photography%2C%20intimate%20close%20up%20composition%2C%20gentle%20shadows&width=800&height=960&seq=superbuy-product-accessories-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Handcrafted%20cognac%20leather%20belt%20coiled%20elegantly%20on%20dark%20walnut%20wood%20grain%20surface%2C%20warm%20directional%20spotlight%20creating%20rich%20texture%20shadows%2C%20artisan%20workshop%20aesthetic%2C%20deep%20warm%20brown%20and%20amber%20tones%2C%20premium%20product%20photography%2C%20dramatic%20lighting%2C%20sophisticated%20masculine%20style%2C%20editorial%20quality&width=800&height=960&seq=superbuy-product-belts-v2&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Glass%20perfume%20bottle%20with%20amber%20colored%20fragrance%20liquid%20on%20reflective%20obsidian%20black%20surface%2C%20warm%20golden%20rim%20lighting%20from%20behind%20creating%20luminous%20glow%20through%20glass%2C%20dramatic%20contrast%2C%20luxury%20product%20photography%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%2C%20sophisticated%20elegant%20composition%2C%20high%20end%20editorial%20style&width=800&height=960&seq=superbuy-product-perfumes-v2&orientation=portrait',
];

const displayCategories = categories.slice(0, 6);

export default function ProductGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="mb-14">
          <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase mb-3">
            Curated Selection
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Curated Product
            <br />
            Spreadsheets
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {displayCategories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group card-base overflow-hidden cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={productImages[index]}
                  alt={`SuperBuy Spreadsheet ${cat.name} Products`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-1">
                  {cat.name}
                </h3>
                <p className="font-body text-xs text-foreground-400">
                  Explore curated {cat.name.toLowerCase()} spreadsheet resources
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="font-body text-sm text-foreground-400 mb-4">
            Discover more categories with detailed product research
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="btn-outline inline-flex items-center"
          >
            View All Categories
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}